var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboardNavIcon = function SvgDashboardNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M20 11a9 9 0 0 1-9 9v-3.59A5.41 5.41 0 0 0 16.41 11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M11 20a9 9 0 0 1-9-9h3.59A5.41 5.41 0 0 0 11 16.41z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M2 11a9 9 0 0 1 9-9v3.59A5.41 5.41 0 0 0 5.59 11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M11 2a9 9 0 0 1 9 9h-3.59A5.41 5.41 0 0 0 11 5.59z"
  })));
};
export default SvgDashboardNavIcon;